import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, WalletIcon, SmartphoneIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
const rows = [{
  content: 'Colección de Planos y Sistemas (5 Tomos)',
  value: '69€'
}, {
  content: 'Pack de Estrategia y Ventas (5 Bonos)',
  value: '89,50€'
}];
const paymentOptions = [{
  icon: CreditCardIcon,
  label: 'Tarjeta de crédito/débito'
}, {
  icon: WalletIcon,
  label: 'Paypal'
}, {
  icon: SmartphoneIcon,
  label: 'Apple Pay / Google Pay'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantizado por Whop'
}];
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-secondary py-10 sm:py-14" data-id="element-134" data-mp="3ct4xz3qfglt">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-135" data-mp="204jk5f8oqfs6">
        <div className="rounded-2xl bg-action px-5 py-3 text-center" data-id="element-136" data-mp="205uvq18dgrtu">
          <p className="text-xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-137" data-mp="252utlov2io9v">
            ⏰ Oferta de lanzamiento: solo 19€ hasta agotar las próximas 50 descargas
          </p>
        </div>
      </div>

      <div className="mx-auto mt-6 max-w-2xl px-4 text-center sm:px-6" data-id="element-138" data-mp="16iyus3z9stqg">
        <SectionTag icon="💰" data-id="element-139" data-mp="11kf9m5si3lz5">Oferta especial de lanzamiento</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-140" data-mp="11iklkilxndqu">
          ¿Cuánto vale para ti dejar de tirar madera y empezar a facturar?
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-141" data-mp="1pahy6bx7i9t0">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-brown/30 bg-white p-6 shadow-card sm:p-7" data-id="element-142" data-mp="1pb16r20yvlud">
          <p className="font-heading text-xs font-bold uppercase tracking-wider text-muted" data-id="element-143" data-mp="9uitxbqpmxy1">
            🔨 El Kit del Taller Rentable
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-144" data-mp="6btrfdskxh8b">5 tomos + 5 bonos, listos para fabricar y vender.</p>

          <div className="mt-4 space-y-1.5" data-id="element-145" data-mp="baob0hydf9th">
            {rows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-brown/10 py-1.5 text-sm" data-id="element-146" data-mp="ba519oivjrqj">
                <span className="text-ink/80" data-id="element-147" data-mp="1cqpi27wbr4k">{row.content}</span>
                <span className="flex-shrink-0 text-muted line-through" data-id="element-148" data-mp="1axgig9t8ute">{row.value}</span>
              </div>)}
            <div className="flex items-center gap-2 py-1.5 text-sm text-ink/80" data-id="element-149" data-mp="3jon51e1s8l4c">
              <CheckIcon size={14} className="flex-shrink-0 text-success" data-id="element-150" data-mp="3oj16ny71fohg" />
              Acceso de por vida a futuras actualizaciones
            </div>
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-ink" data-id="element-151" data-mp="3er3qed16a6bv">
              <span data-id="element-152" data-mp="30rc8403mi3s2">VALOR TOTAL</span>
              <span data-id="element-153" data-mp="30sdswwafy4mz">158,50€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-154" data-mp="35r8a5tsrfl4z">Consíguelo hoy por solo:</p>
          <p className="font-heading text-5xl font-extrabold text-brown sm:text-6xl" data-id="element-155" data-mp="2m4n71ttq3ijk">19€</p>
          <p className="mt-2 text-sm text-danger" data-id="element-156" data-mp="2h6bz5omzni3z">⏰ Descuento del 88% — solo para los próximos 50 pedidos</p>

          <div className="mt-6" data-id="element-157" data-mp="2v6d0t6b2utki">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-action px-8 py-4 font-heading text-base font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-action-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-158" data-mp="2v7eny95db6il">
              🔨 Quiero empezar ahora
            </a>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-brown/10 pt-4 text-[11px] text-muted" data-id="element-159" data-mp="39vsogdfbaivz">
            {paymentOptions.map(item => <span key={item.label} className="flex items-center gap-1.5" data-id="element-160" data-mp="3ns62tdoju468">
                <item.icon size={13} className="flex-shrink-0" data-id="element-161" data-mp="3ix8xagqhacy3" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}